import React, { useContext } from "react";
import { Grid, Paper, Typography, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { userRegisterContext } from "../../UserRegisterPage";

export default function UserClassField() {
  const { userClass, setUserClass } = useContext(userRegisterContext);

  const handleChangeUserClass = (e) => {
    setUserClass(Number(e.target.value));
  };

  const bpManagementClass = Number(process.env.REACT_APP_BP_MANAGEMENT_CLASS);
  const generalClass = Number(process.env.REACT_APP_GENERAL_CLASS);

  return (
    <Paper elevation={0} sx={{ borderBottom: 1, borderColor: "#F2F3F4" }}>
      <Grid container justifyContent="center" alignItems="center">
        <Grid
          item
          xs={4}
          sm={2.5}
          sx={{ fontWeight: "bold", p: "20px", pl: "20px" }}
        >
          ユーザ区分
        </Grid>
        <Grid
          item
          xs={8}
          sm={9.5}
          sx={{ my: "20px", fontSize: 16, pl: "15px" }}
        >
          <RadioGroup value={userClass} row onChange={handleChangeUserClass}>
            <FormControlLabel
              value={bpManagementClass}
              label={<Typography fontSize={16}>BP管理者</Typography>}
              control={
                <Radio
                  size="small"
                  sx={{ "&.Mui-checked": { color: "#28345E" } }}
                />
              }
            />
            <FormControlLabel
              value={generalClass}
              label={<Typography fontSize={16}>一般ユーザ</Typography>}
              control={
                <Radio
                  size="small"
                  sx={{ "&.Mui-checked": { color: "#28345E" } }}
                />
              }
            />
          </RadioGroup>
        </Grid>
      </Grid>
    </Paper>
  );
}